import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const commandPaletteHostStyleId = 'wb-v2-command-palette-host-theme';

export const commandPaletteHostBridgeStyles = {
  'command-palette-host': {
    '--local-cp-scope-bg': tokens.color.background.secondarySubtle,
    '--local-cp-scope-color': tokens.color.text.secondary,
    '--local-cp-scope-border': tokens.color.border.secondary,
  },
};
